import { invisibleQnaTabForPC, invisibleQnaTabForMobile } from './temporay';

export default class TabNavigation {
  PREV_TAB_ID = '';

  CURRENT_TAB_ID = '';

  PARAM_TAB_ID =
    TMON.util.getHashJSON().tab || TMON.oApp.oUtil.getUrlParams().tab || '';

  DEFAULT_TAB_ID = $('[data-role=content-rely-tab]:first').attr('data-name');

  ACTIVE_TAB_ID = '';

  // 탭 오른쪽 카운터 최대 값
  MAX_COUNT = 99999;

  constructor() {
    this.setEvent();
    this.render();
    this.setMinHeightTosection();
    this.setIoApi();
    if (this.PARAM_TAB_ID) {
      this.enableTab({ sTabId: this.PARAM_TAB_ID, bScrollToTab: true });
    } else {
      this.CURRENT_TAB_ID = this.DEFAULT_TAB_ID;
      this.enableTab({ sTabId: this.CURRENT_TAB_ID, bScrollToTab: false });
    }
    this.ACTIVE_TAB_ID = $('.tab-navigation .selected a').data('tab-id');
  }

  setEvent() {
    $('#tab-navigation').on('click', 'a', $.proxy(this.onClickTabItem, this));
  }

  clearEvent() {
    $('#tab-navigation').off('click', 'a');
  }

  setIoApi() {
    const io = new TMON.IntersectionObserver((entry, observer) => {
      if (entry.isIntersecting) {
        // qna list 조회
        TMON.oApp.oQna.init();
        observer.unobserve(entry.target);
      }
    });
    io.observe($('#tab-navigation'));
  }

  update(sStorageKey) {
    if (sStorageKey === 'defaultFinally') {
      if (this.PARAM_TAB_ID) {
        this.enableTab({ sTabId: this.PARAM_TAB_ID, bScrollToTab: true });
      }
    }

    // 카운트 지정된 숫자 넘어가면 고정값이상 안넘어가지고 후치는 + 처리 될수 있도록 구분
    const overNumber = (n, v) => {
      let resultNum = n;
      let resultStr = '';

      if ($.isNumeric(n)) {
        const num = parseInt(n, 10);
        if (num >= v) {
          resultNum = v;
          resultStr = '+';
        }
      }

      return [resultNum, resultStr];
    };

    // MW/MA에서도 기능 추가로 주석 처리
    // PW 경우에만 qna, review list 개수 노출 (MW, MA 고려해 UpdateRequireKey는 유지)
    // if (TMON.oApp.sPlatform === 'PW') {
    const setCount = (wel, text) => {
      const welCount = wel.find('span');
      const [num, addStr] = overNumber(text, this.MAX_COUNT);
      const count = TMON.util.numberWithComma(num) || 0;
      if (welCount.length === 0) {
        wel.append(`<span class="number">${count}${addStr}</span>`);
      } else {
        welCount.text(`${count}${addStr}`);
      }
    };

    const bIsDataExist = Object.prototype.hasOwnProperty.call(
      TMON.oApp.htStorage[sStorageKey] || {},
      'data'
    );
    if (!bIsDataExist) return;
    if (sStorageKey === 'qnaList') {
      const welQna = $('#tab-navigation').find('[data-tab-id=qna-section]');
      setCount(welQna, TMON.oApp.htStorage.qnaList.data.userViewCount);
    } else if (sStorageKey === 'representativeReview') {
      const welReview = $('#tab-navigation').find('[data-tab-id=review]');
      setCount(
        welReview,
        TMON.oApp.htStorage.representativeReview.data.reviewCount
      );
    }
    // }
  }

  /**
   * 탭내비게이션의 앵커가 동작했을 때 호출
   * @param {object} e event 객체
   */
  onClickTabItem(e) {
    const sTabId = $(e.currentTarget).attr('data-tab-id');
    if (this.ACTIVE_TAB_ID === 'description') {
      this.nDescScrollHeight = $(window).scrollTop();
    }
    this.ACTIVE_TAB_ID = sTabId;
    this.enableTab({ sTabId, bScrollToTab: true });
    if (sTabId === 'description') {
      TMON.util.removeHash('tab')
    } else {
      TMON.util.setHash('tab', sTabId);
    }
    e.preventDefault();
  }

  enableTab(htTabInfo) {
    const htRefineTabInfo = htTabInfo;

    // 지정된 탭이 존재하지 않을 경우 DEFAULT_TAB_ID 로 교체한다.
    if ($(`a[data-tab-id=${htRefineTabInfo.sTabId}]`).length < 1) {
      htRefineTabInfo.sTabId = this.DEFAULT_TAB_ID;
    }
    // 상품설명탭 에서 다른 탭으로 이동 후 상품설명 탭으로 돌아오는 경우 탭 이동 전 스크롤 위치를 기억하고 해당 위치로 스크롤한다.
    if (htRefineTabInfo.sTabId === 'description' && this.nDescScrollHeight) {
      htRefineTabInfo.nScrollHeight = this.nDescScrollHeight;
    }
    TMON.oApp.enableTab(htRefineTabInfo);
  }

  render() {
    const {
      reviewType,
      htStaticData: { bIsDeliveryDeal, htDealInfo, isShowReview, isShowQna },
    } = TMON.oApp.htStorage;

    let htTabInfo = {};

    let tlArea = '';

    if (TMON.oApp.sPlatform === 'PW') {
      tlArea = 'TCC0';

      htTabInfo = {
        description: {
          name: '상품설명',
          id: 'description',
          ord: 1,
        },
      };

      if (reviewType.data !== 'N') {
        htTabInfo.review = {
          name: '리뷰',
          id: 'review',
          ord: 3,
        };
      }

      htTabInfo.qnaSection = {
        name: '문의',
        id: 'qna-section',
        ord: 2,
      };

      htTabInfo.claim = {
        name: '환불/교환',
        id: 'claim',
        ord: 4,
      };

      // 배송딜이 아닐 때는 '취소환불/상품고시'로 탭명을 변경한다.
      if (!bIsDeliveryDeal) {
        htTabInfo.claim = {
          name: '취소/환불',
          id: 'claim',
          ord: 4,
        };
      }
    } else {
      tlArea = 'DCC0';

      htTabInfo = {
        description: {
          name: '상품설명',
          id: 'description',
          ord: 1,
        },
      };

      // 리뷰 Api 에러로 검증 주석
      if (reviewType.data !== 'N') {
        htTabInfo.review = {
          name: '리뷰',
          id: 'review',
          ord: 5,
        };
      }

      htTabInfo.qnaSection = {
        name: '문의',
        id: 'qna-section',
        ord: 3,
      };

      htTabInfo.claim = {
        name: '환불/교환',
        id: 'claim',
        ord: 4,
      };

      // 배송딜이 아닐 때는 '취소환불/상품고시'로 탭명을 변경한다.
      if (!bIsDeliveryDeal) {
        htTabInfo.claim = {
          name: '취소/환불',
          id: 'claim',
          ord: 4,
        };
      }
    }

    // TMON.htCommonStaticInfo.deal.isReviewQna()
    // 신차 or 인증중고자동차 카테고리일 때 리뷰/문의 제거, 신차>캠핑카 일때는 제거하지 않음
    // 리뷰 탭 삭제
    if (TMON.htCommonStaticInfo.deal.isReviewQna() || !isShowReview) {
      delete htTabInfo.review;
    }

    // 문의 탭 삭제
    if (TMON.htCommonStaticInfo.deal.isReviewQna() || !isShowQna) {
      delete htTabInfo.qnaSection;
    }

    // [SDLUI-1281] 상품문의 비노출 임시코드
    if (TMON.oApp.sPlatform === 'PW') {
      invisibleQnaTabForPC(htTabInfo, reviewType);
    } else {
      invisibleQnaTabForMobile(htTabInfo, reviewType);
    }

    // 배송딜이거나 업체정보 없을 때
    if (htDealInfo.bIsDeliveryDeal || htDealInfo.localShopList.length < 1) {
      delete htTabInfo.partnerInfo;
    }

    // [SDLUI-1049] 티몬팩토리 딜에 대해서 환불탭, 상품고시 미노출(dealNo: number)
    if (htDealInfo.dealNo === 2351293706 || htDealInfo.dealNo === 2351352802) {
      delete htTabInfo.claim;
      if (TMON.oApp.sPlatform !== 'PW') {
        $('#detailInfo')
          .find('#_wrapProductInfoNotes')
          .remove();
      }
    }

    const sTemplate = `<ul class="tab-navigation">
                ${Object.keys(htTabInfo)
                  .map(
                    item =>
                      `<li>
                              <a href="#tab=${htTabInfo[item].id}" data-tab-id="${htTabInfo[item].id}" data-tlarea="${tlArea}" data-tlord="${htTabInfo[item].ord}">
                                  ${htTabInfo[item].name}
                              </a>
                          </li>`
                  )
                  .join('')}
            </ul>`;

    $('#tab-navigation .tab-inner').html(sTemplate);
  }

  setMinHeightTosection() {
    const nWindowHeight =
      $(window).height() -
      ($('header.hdr.blurred').outerHeight()
        ? $('header.hdr.blurred').outerHeight()
        : 0) -
      $('.tab-navigation').outerHeight() -
      $('[data-role=prchWrap]:first').outerHeight();
    $('section[data-role=content-rely-tab]').css('min-height', nWindowHeight);
  }
}
